import { handleActions } from 'redux-actions';

import { SeatMapPassenger } from '../types';
import { setPassengers, SetPassengersAction } from './actions';

const initialState: SeatMapPassenger[] = [];

const passengersReducer = handleActions(
	{
		[setPassengers.toString()]: (_, { payload }: SetPassengersAction) => payload
	},
	initialState
);

export default passengersReducer;
